<template>
  <div class="rowd gap24 chat-container w100">
    <ChatList style="flex: 0.8" />
    <Chat style="flex: 1.2" class="w100" />
  </div>
</template>

<script>
import Chat from "../../BuySell/Negotiation/Chat.vue";
import ChatList from "./ChatsList.vue";
export default {
  name: "Chats",
  components: {
    Chat,
    ChatList,
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .chat-container {
    flex-direction: column;
    .mini-container {
      flex: 1;
      width: 100%;
    }
  }
}
</style>
